module.exports = __webpack_public_path__ + "static/media/1.6.245794d7.png";